import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { KeyValuePair } from 'helpers';
import { TicketPriority } from 'helpers/Enums';
import { Dictionary } from 'lodash';


interface IApplicationContext {
    isLoading: boolean
    ticketCategories: ITicketCategory[]
    ticketSubCategories: ITicketSubCategory[]
    ticketPriorities: KeyValuePair<TicketPriority, string>[]
    ticketStatuses: ITicketStatus[]

    getCategoryById: (id: string) => ITicketCategory | undefined
    getSubCategoryById: (id: string) => ITicketSubCategory | undefined
}

interface ITicketCategory {
    ticketCategoryId: string
    defaultAssignee: string
    names: Dictionary<string>,
    color: string,
    fromCustomer: boolean
    subCategories: ITicketCategorySubCategory[]
}

interface ITicketCategorySubCategory {
    id: string
    names: Dictionary<string>
}

interface ITicketStatus {
    code: string
    descriptions: Dictionary<string>
}

interface ITicketSubCategory {
    id: string

    // category data
    categoryTicketCategoryId: string
    categoryNames: Dictionary<string>,
    categoryColor: string,

    // subcategory data
    names: Dictionary<string>
}

export let customerApplicationContext = React.createContext({} as IApplicationContext);

let { Provider } = customerApplicationContext;

let CustomerApplicationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    let [isLoading, setLoading] = useState(true);

    let [ticketPriorities, setTicketPriorities] = useState<KeyValuePair<TicketPriority, string>[]>([]);
    let [ticketStatuses, setTicketStatuses] = useState<ITicketStatus[]>([]);
    let [ticketCategories, setTicketCategories] = useState<ITicketCategory[]>([]);
    let [ticketSubCategories, setTicketSubCategories] = useState<ITicketSubCategory[]>([]);


    useEffect(() => {
        let getCustomerRefData = async () => {
            try {
                setLoading(true);

                let res = await axios.get('/api/CustomerApplication/GetAllCustomerReferenceData');

                let { item } = res.data;
                setTicketCategories(item.ticketCategories);
                setTicketSubCategories(item.ticketSubCategories);
                setTicketStatuses(item.ticketStatuses);
                setTicketPriorities(item.ticketPriorities);

            } catch (err) { }
            finally {
                setLoading(false);
            }
        }

        getCustomerRefData();
    }, [])


    let getCategoryById = (id: string) => {
        return ticketCategories.find(x => x.ticketCategoryId === id);
    }

    let getSubCategoryById = (id: string) => {
        return ticketSubCategories.find(x => x.id === id);
    }


    return (
        <Provider value={{
            isLoading,
            ticketCategories,
            ticketSubCategories,
            ticketPriorities,
            ticketStatuses,

            getCategoryById,
            getSubCategoryById
        }}>
            {children}
        </Provider>
    )
}

export default CustomerApplicationProvider;